import {CornerDownIcon} from '@logistics-frontend/blocks'
import React from 'react'

import {
  DetailsSection,
  DetailsSectionItem,
  DetailsSectionItemAccordion,
  DetailsSectionItemSubtitle,
} from 'src/api/cargo-c2c/types'

import {Accordion, AccordionDetails, AccordionSummary} from '../accordion'
import {Item, List} from '../info'
import {classes} from '../info/styles'

const isDetailsSectionItemAccordion = (sectionItem: DetailsSectionItem): sectionItem is DetailsSectionItemAccordion => {
  return sectionItem.type === 'accordion'
}

const isDetailsSectionItemSubtitle = (sectionItem: DetailsSectionItem): sectionItem is DetailsSectionItemSubtitle => {
  return sectionItem.type === 'subtitle'
}

type Props = {
  sections: DetailsSection[]
}

const DetailsList: React.FC<Props> = ({sections}) => {
  return (
    <>
      {sections.map((section, indexList) => {
        return (
          <List key={`list_${indexList}`} title={section.title}>
            {section.items.map(item => {
              if (isDetailsSectionItemSubtitle(item)) {
                return (
                  <Item key={item.title} description={item.subtitle}>
                    {item.title}
                  </Item>
                )
              }
              if (isDetailsSectionItemAccordion(item)) {
                return (
                  <Accordion key={item.title}>
                    <AccordionSummary expandIcon={<CornerDownIcon data-e2e="info-partner" />}>
                      <div className={classes.primary}>{item.title}</div>
                    </AccordionSummary>
                    <AccordionDetails>
                      {item.items.map(item =>
                        'title' in item ? (
                          <Item key={item.title} description={item.subtitle}>
                            {item.title}
                          </Item>
                        ) : null,
                      )}
                    </AccordionDetails>
                  </Accordion>
                )
              }

              return null
            })}
          </List>
        )
      })}
    </>
  )
}

export default DetailsList
